<template>
  <div class="container">
  </div>
</template>

<script>
export default {
  name: "solid",
  components: {},
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.container{
  margin: 0 auto;
  margin-top: 47px;
  width: 837px;
  height: 1px;
  border-top: 2px dotted #A82CEC;
}
</style>